import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import { MiscService } from "app/shared/misc.service";
import { environment } from "environments/environment";
import { retry } from "rxjs/operators";


@Injectable({
    providedIn: 'root'
})

export class AuthorizerService {
    constructor(
        private http : HttpClient,
        private appStorage: AppLocalStorage,
        private miscService: MiscService
    ){}

    getSelectedCountryFromSession(){
        return this.appStorage.getFromStorage('userCountry').iso_code_2
    }

    getMerchantAuthorizers = () => this.http.get(`${environment.MERCHANT_AUTH_URL}/api/authorizers/${this.miscService.getMerchantDetails().merchant_id}`)

    createMerchantAuthorizer = (resource) => this.http.post(`${environment.MERCHANT_AUTH_URL}/api/authorizer/create`, resource) 

    deleteMerchantAuthorizer = (authorizerID) => this.http.delete(`${environment.MERCHANT_AUTH_URL}/api/authorizer/delete/${authorizerID}/${this.miscService.getMerchantDetails().merchant_id}`) 

}